var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65.975C-.003 2-.328 5.203.297 7.815c.486 2.033 1.52 4.76 3.265 7.33 1.64 2.416 3.93 4.582 5.676 5.836 2.241 1.61 5.437 2.633 7.091 1.608.349-.216.768-.588 1.143-.966.71-.718.672-1.696.105-2.532l-2.444-3.6c-.182-.267-1.321-.022-1.9.29-.317.172-.624.461-.877.744-.448.501-.98 1.05-1.61.812-.256-.097-.555-.244-.933-.41-1.151-.506-2.446-2.078-3.476-3.502-.94-1.479-1.916-3.249-1.93-4.459-.005-.397-.023-.717-.011-.98.03-.651.745-.887 1.373-1.057.39-.106.819-.26 1.128-.478.535-.377 1.233-1.27 1.052-1.538l-2.445-3.6C4.933.473 4.042.041 3.08.36c-.527.174-1.07.393-1.428.615Z",
    fill: "#151739"
  })));
};
export default SvgPhone;